import { Dispatch } from 'redux';

import {
  ACTION_POST_JOB_TRIGGER,
  ACTION_POST_JOB_TRIGGER_SUCCESS,
  ACTION_POST_JOB_TRIGGER_FAILURE,
  ACTION_RESET_JOB_TRIGGER,
  API_CALL,
} from '../../configs/ActionTypes';

import {
  enqueueSnackbarCustomMessageHandler,
  enqueueSnackbarHandler,
} from '../Status';

export type TriggerJobPayload = {
  jobName: string;
  body: Record<string, unknown>;
  options?: Record<string, unknown>;
};

export function triggerJob(payload: TriggerJobPayload) {
  return (dispatch: Dispatch, getState: Function) => {
    dispatch(requestStarted());

    dispatch({
      type: API_CALL,
      payload: {
        call: 'job/trigger-job',
        method: 'post',
        data: JSON.stringify(payload),
        success: (response: object) => {
          dispatch(requestSuccess(response));
          enqueueSnackbarCustomMessageHandler(
            dispatch,
            'Job scheduled successfully.',
            'success',
          );
        },
        fail: (error: any) => {
          enqueueSnackbarHandler(dispatch, error.payload, 'error');
          if (typeof error?.payload?.message === 'string') {
            enqueueSnackbarCustomMessageHandler(
              dispatch,
              error.payload.message,
              'error',
            );
          }
          dispatch(requestFailed(error));
        },
      },
    });

    return null;
  };
}

export function requestStarted() {
  return {
    type: ACTION_POST_JOB_TRIGGER,
    payload: null,
  };
}

export function requestSuccess(responseJSON: object) {
  return {
    type: ACTION_POST_JOB_TRIGGER_SUCCESS,
    payload: responseJSON,
  };
}

export function requestFailed(responseJSON: object) {
  return {
    type: ACTION_POST_JOB_TRIGGER_FAILURE,
    payload: responseJSON,
  };
}

export function resetTriggerJobStatus() {
  return (dispatch: Dispatch, getState: Function) => {
    dispatch({
      type: ACTION_RESET_JOB_TRIGGER,
      payload: null,
    });
  };
}
